<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>
<style lang="less" scoped>
// #app {
//   width: 1920px;
//   height: 1080px;
//   position: absolute;
//   left: 50%;
//   top: 50%;
//   margin-left: -960px;
//   margin-top: -540px;
// }
//
</style>
